/**
 * S39: ilgili kişinin veri paketi ve başvuru takibi; panel ve çalışan uygulamasında ortak metin. S41 (Faz 6
 * değerlendirmesi No 2, 11, 18): sonuçlandırma önizlemesi, alana bağlı form hataları, şirket saatinde alış zamanı, biçim
 * etiketleri ve "İşlemeye itiraz" (puantaj itirazıyla karışmasın diye).
 */
export const privacy = {
  title: 'Verilerim',
  body: 'Şirketinizde tutulan mesai, puantaj, izin ve doğrulama kayıtlarınızı indirin veya verilerinizle ilgili başvuru yapın.',
  exports: 'Veri paketlerim',
  exportBody: 'Paket arka planda hazırlanır. İndirme bağlantısı 24 saat geçerlidir; dosya saklama süresi şirketinizin Veri ve KVKK ayarında görünür.',
  prepare: 'Veri paketimi hazırla',
  formatLabel: 'Dosya biçimi',
  formats: { Pdf: 'PDF belgesi', Json: 'JSON dosyası' },
  formatHints: {
    Pdf: 'Okumak, yazdırmak ve saklamak için.',
    Json: 'Verilerinizi başka bir sisteme aktarmak için; makinece okunur.',
  },
  download: 'İndir', downloadLabel: '{format} paketini indir', preparing: 'Paketiniz hazırlanıyor.',
  exportCreated: 'Veri paketiniz hazırlama sırasına alındı.', exportEmpty: 'Henüz veri paketi istemediniz.',
  status: 'Durum', created: 'Oluşturulma', expires: 'Bağlantı sonu', rows: 'Kayıt', actions: 'İşlem', format: 'Biçim',
  exportExpired: 'İndirme süresi doldu. Yeni bir paket hazırlayın.',
  exportStatus: { Queued: 'Hazırlanıyor', Ready: 'Hazır', Failed: 'Üretilemedi' },
  requests: 'Veri sahibi başvuruları',
  requestsBody: 'Başvuruların yanıt süresi, alınmasından itibaren 30 gündür. Silme taleplerinde yasal saklama kontrol edilir; saklanması gereken kayıtların işlenmesi kısıtlanır.',
  request: 'Başvuru yap', record: 'Başvuru kaydet', resolve: 'Sonuçlandır', response: 'Yanıtı indir',
  type: 'Başvuru türü', description: 'Başvurunuzu açıklayın', subject: 'Çalışan',
  subjectPlaceholder: 'Ad veya sicille arayın', subjectNumber: 'Sicil {number}', subjectLeft: 'Ayrıldı',
  received: 'Alış tarihi', receivedOptional: 'Başka kanaldan gelen başvurunun alış zamanı (isteğe bağlı)',
  receivedDate: 'Alış tarihi', receivedTime: 'Alış saati', receivedDatePlaceholder: 'GG.AA.YYYY',
  receivedZone: 'Şirketinizin saat dilimine göredir ({zone}). Boş bırakırsanız kayıt anı kullanılır; 30 günlük yanıt süresi alış zamanından sayılır.',
  due: 'Son yanıt tarihi', remaining: '{days} gün kaldı', overdue: '{days} gün gecikti',
  requestEmpty: 'Başvuru bulunmuyor.', saved: 'Başvurunuz kaydedildi.', handled: 'Başvuru sonuçlandırıldı.',
  reason: 'İşlem açıklaması', reasonBody: 'Erişim, düzeltme ve işlemeye itiraz başvurularında yaptığınız işlemi açıklayın. Silmede saklama kontrolü sonucu ve gerekçeli yanıt otomatik eklenir.',
  restriction: 'İşleme kısıtlı: olağan raporlarda kullanılmaz; yasal yükümlülük ve kendi verinize erişim sürer.',
  template: 'Ret şablonu TicariShift\'in önerisidir; gerekirse düzenleyin.',
  invalidReason: 'En fazla 3.000 karakterlik bir işlem açıklaması yazın.',
  errors: {
    subject: 'Çalışanı seçin.',
    description: 'Başvuruyu açıklayın.',
    descriptionOwn: 'Başvurunuzu açıklayın.',
    descriptionLength: 'Açıklama en fazla 2.000 karakter olabilir.',
    receivedDate: 'Alış tarihini GG.AA.YYYY biçiminde yazın.',
    receivedTime: 'Alış saatini SS:DD biçiminde yazın (ör. 09:30).',
    receivedFuture: 'Alış zamanı gelecekte olamaz.',
  },
  eraseConfirm: {
    title: 'Silme başvurusu sonuçlandırılsın mı?',
    body: 'Yasal saklama süresi dolmuşsa kişinin kimlik bilgileri anonimleştirilir ve hazırlanmış veri paketleri silinir; bu geri alınamaz. Saklama süresi sürüyorsa başvuru gerekçeli ret olur ve kayıtların işlenmesi kısıtlanır.',
    phrase: 'SONUÇLANDIR',
  },
  preview: {
    title: 'Sonuçlandırınca ne olur',
    loading: 'Sonuç hesaplanıyor.',
    error: 'Sonuç önceden hesaplanamadı.',
    retry: 'Sonucu yeniden hesapla',
    anonymize: 'Saklama süresi dolmuş: kişinin kimlik bilgileri anonimleştirilir; puantaj ve izin toplamları korunur. Bu geri alınamaz.',
    anonymizeSummary: '{count} kayıt türü işlenir: {anonymize} anonimleştirilir, {delete} silinir, {mask} maskelenir.',
    categories: 'İşlenecek kayıt türleri',
    actions: { Anonymize: 'anonimleştirilir', Delete: 'silinir', Mask: 'maskelenir' },
    packages: 'Hazırlanmış {count} veri paketi silinir.',
    noPackages: 'Silinecek veri paketi yok.',
    reject: 'Saklama sürüyor: başvuru gerekçeli ret olur ve kişinin kayıtlarının işlenmesi kısıtlanır. Hiçbir kayıt silinmez.',
    reasonsTitle: 'Ret nedeni',
    reasons: {
      LegalHold: 'Kişi ya da şirket için açık yasal saklama kaydı var.',
      EmploymentContinues: 'Kişinin istihdamı sürüyor.',
      RecordsWithinRetention: 'Kişinin kayıtları yasal saklama süresinin içinde.',
    },
    retention: 'Saklama süresi {years} yıl; dayanak: {basis}.',
    latest: 'Kişinin en yeni kaydı: {date}.',
    alreadyRestricted: 'Kişinin kayıtları başka bir başvuruyla zaten işlemeye kısıtlı.',
    asOf: 'Sonuç şu anki kayıtlara göredir; yeni kayıt ya da yasal saklama eklenirse değişebilir.',
  },
  types: { Access: 'Erişim', Correction: 'Düzeltme', Erase: 'Silme', Objection: 'İşlemeye itiraz' },
  typeHints: {
    Access: 'Hangi kişisel verilerin işlendiğini ve nasıl işlendiğini öğrenme.',
    Correction: 'Eksik ya da yanlış kişisel verilerin düzeltilmesi.',
    Erase: 'Kişisel verilerin silinmesi ya da anonimleştirilmesi; yasal saklama süresi kontrol edilir.',
    Objection: 'Kişisel verilerin işlenmesine itiraz. Puantajdaki bir güne itiraz bu başvuruyla değil, Puantajım ekranından yapılır.',
  },
  requestStatus: { Received: 'Yanıt bekliyor', Completed: 'Sonuçlandırıldı', Rejected: 'Gerekçeli ret' },
} as const;
